import * as _ from 'lodash';
import * as moment from 'moment';
import { ClonableItem } from 'src/app/shared/models/clonable-item';
import { DATETIME_FORMAT, UTC_DATETIME_FORMAT } from 'src/app/shared/utils/utils';
import { SchedulerStatus } from '../enums/scheduler-status.enum';
import { ISchedulerSettings } from '../interfaces/scheduler-settings.interface';

export class SchedulerSettings extends ClonableItem<ISchedulerSettings> implements ISchedulerSettings {
    turnOnScheduler: boolean;
    checkIntervalSeconds: number;
    maxConcurrentProcesses: number;
    pauseDuration: number;
    pauseStart: moment.Moment;
    pauseEnd: moment.Moment;
    maxThreadsCount: number;
    maxPRsBunchSizeAllowed: number;
    defaultMaxPRsBunchSize: number;

    processUseGAPIDataCache?: boolean; // TODO :: not used yet
    processMaxCacheSizePst?: number; // TODO :: not used yet
    maxCacheSizeMb?: number; // TODO :: not used yet
    processDataTTLSec?: number; // TODO :: not used yet
    processTTLResolutionSec?: number; // TODO :: not used yet

    maxProcessThreadTTLMin?: number;
    processTreadsTTLResolutionSec?: number;
    isProcessThreadsTTLCheckerActive?: boolean;

    garbageCollectorSchedulerIntervalMin?: number;
    isGarbageCollectorSchedulerActive?: boolean;

    constructor(value: ISchedulerSettings) {
        super(value);
    }

    get status(): SchedulerStatus {
        return this.turnOnScheduler
            ? this.isPaused
                ? SchedulerStatus.PAUSED
                : SchedulerStatus.IN_PROGRESS
            : SchedulerStatus.OFF;
    }

    get isPaused(): boolean {
        return this.pauseEnd && this.pauseEnd > moment();
    }

    get pauseStartStr(): string {
        return this.pauseStart ? this.pauseStart.format(DATETIME_FORMAT) : '';
    }

    get pauseEndStr(): string {
        return this.pauseEnd ? this.pauseEnd.format(DATETIME_FORMAT) : '';
    }

    get pauseStartUTCStr(): string {
        return this.pauseStart ? this.pauseStart.utc().format(UTC_DATETIME_FORMAT) : null;
    }

    get pauseEndUTCStr(): string {
        return this.pauseEnd ? this.pauseEnd.utc().format(UTC_DATETIME_FORMAT) : null;
    }

    get pauseInfo(): string {
        return `Duration: ${this.pauseDuration} hour(s), start: ${this.pauseStartStr}`;
    }

    setPauseDuration(pauseDuration: number) {
        this.pauseDuration = pauseDuration;
        if (!this.pauseDuration) {
            return;
        }
        this.pauseStart = moment().utc();
        this.pauseEnd = moment.utc(this.pauseStart).add(this.pauseDuration || 0, 'h');
    }

    clearPause() {
        this.pauseDuration = null;
        this.pauseStart = null;
        this.pauseEnd = null;
    }

    getJSON() {
        return _.pick(this, [
            'turnOnScheduler',
            'checkIntervalSeconds',
            'maxConcurrentProcesses',
            'pauseDuration',
            'pauseStart',
            'pauseEnd',
            'maxThreadsCount',
            'maxPRsBunchSizeAllowed',
            'defaultMaxPRsBunchSize',

            'processUseGAPIDataCache',
            'processMaxCacheSizePst',
            'maxCacheSizeMb',
            'processDataTTLSec',
            'processTTLResolutionSec',

            'optimalThreadsPerEc2InstanceCount',
            'threadsIncreaseIntervalMin',
            'threadsIncreaseSchedulerActive',

            'maxProcessThreadTTLMin',
            'processTreadsTTLResolutionSec',
            'isProcessThreadsTTLCheckerActive',

            'garbageCollectorSchedulerIntervalMin',
            'isGarbageCollectorSchedulerActive'
        ]);
    }
}

export function SchedulerSettingsFactory(data: ISchedulerSettings) {
    return new SchedulerSettings(data);
}
